/**
 * Filtros avançados da lista (os mesmos da tela anterior): faixa de saúde,
 * vendedor, consultor, obra futura e intervalos de valor, atraso, pedidos e
 * próxima entrega. Abre do botão "Filtros".
 */
import React, { useState } from "react";

import FilterPanel from "../../../../components/FilterPanel";
import {
  FilterField,
  FilterGrid,
  FilterInlineGroup,
  FilterInput,
  FilterLabel,
  FilterSelect,
} from "../../styles";
import { contarFiltrosAvancados } from "../dados/filtros";
import { FAIXAS, ROTULO_DA_FAIXA } from "../dados/regras";

function Intervalo({ rotulo, de, ate, filtros, aoMudar, tipo = "number" }) {
  // Dinheiro é digitação livre pt-BR (ADR-0059): texto, lido com parseDinheiro.
  const dinheiro = tipo === "dinheiro";
  const tipoDoCampo = dinheiro ? "text" : tipo;
  const inputMode = dinheiro ? "decimal" : undefined;
  const min = tipo === "number" ? "0" : undefined;
  return (
    <FilterField>
      <FilterLabel>{rotulo}</FilterLabel>
      <FilterInlineGroup>
        <FilterInput type={tipoDoCampo} inputMode={inputMode} min={min} value={filtros[de]}
          onChange={(e) => aoMudar(de, e.target.value)} placeholder="De" aria-label={`${rotulo}: de`} />
        <FilterInput type={tipoDoCampo} inputMode={inputMode} min={min} value={filtros[ate]}
          onChange={(e) => aoMudar(ate, e.target.value)} placeholder="Até" aria-label={`${rotulo}: até`} />
      </FilterInlineGroup>
    </FilterField>
  );
}

function Selecao({ rotulo, campo, filtros, aoMudar, opcoes }) {
  return (
    <FilterField>
      <FilterLabel>{rotulo}</FilterLabel>
      <FilterSelect value={filtros[campo]} onChange={(e) => aoMudar(campo, e.target.value)}>
        <option value="">Todos</option>
        {opcoes.map((o) => <option key={o.valor} value={o.valor}>{o.rotulo}</option>)}
      </FilterSelect>
    </FilterField>
  );
}

export default function FiltrosAvancados({ filtros, aoMudar, aoLimpar, vendedores, consultores, visiveis, total }) {
  const [aberto, setAberto] = useState(false);
  const ligados = contarFiltrosAvancados(filtros);
  const comoOpcao = (lista) => lista.map((v) => ({ valor: v, rotulo: v }));

  return (
    <div className="cl-filtros">
      <FilterPanel
        compact
        title="Filtros de clientes"
        triggerLabel={ligados ? `Filtros (${ligados})` : "Filtros"}
        meta={`${visiveis} de ${total} clientes visíveis`}
        open={aberto}
        onToggle={() => setAberto((a) => !a)}
        onClose={() => setAberto(false)}
        onReset={aoLimpar}
      >
        <FilterGrid>
          <Selecao rotulo="Faixa de saúde" campo="faixa" filtros={filtros} aoMudar={aoMudar}
            opcoes={Object.values(FAIXAS).map((f) => ({ valor: f, rotulo: ROTULO_DA_FAIXA[f] }))} />
          <Selecao rotulo="Vendedor" campo="vendedor" filtros={filtros} aoMudar={aoMudar} opcoes={comoOpcao(vendedores)} />
          <Selecao rotulo="Consultor" campo="consultor" filtros={filtros} aoMudar={aoMudar} opcoes={comoOpcao(consultores)} />
          <Selecao rotulo="Obra futura" campo="obraFutura" filtros={filtros} aoMudar={aoMudar}
            opcoes={[{ valor: "sim", rotulo: "Com obra futura" }, { valor: "nao", rotulo: "Sem obra futura" }]} />
          <Intervalo rotulo="Valor total" de="valorMin" ate="valorMax" filtros={filtros} aoMudar={aoMudar} tipo="dinheiro" />
          <Intervalo rotulo="Atraso acumulado (dias)" de="atrasoMin" ate="atrasoMax" filtros={filtros} aoMudar={aoMudar} />
          <Intervalo rotulo="Total de pedidos" de="pedidosMin" ate="pedidosMax" filtros={filtros} aoMudar={aoMudar} />
          <Intervalo rotulo="Próxima entrega" de="entregaDe" ate="entregaAte" filtros={filtros} aoMudar={aoMudar} tipo="date" />
        </FilterGrid>
      </FilterPanel>
    </div>
  );
}
